import React from 'react'
import Grid from '@mui/material/Grid2';
import "./catalogs.css";
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import CatalogCategory from '../../../components/catalog/CatalogCategory';
function ConsultingServices() {
    const navigate = useNavigate();
    // const permissionstest = JSON.parse(localStorage.getItem('permissions'));
  return (
    <div className='container-fluid px-0'>
        <CatalogCategory/>
        <div className='content_container_articals'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Consulting Services</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Catalog <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Consulting Services</span>
                    </Grid>
                </Grid>
                <Grid size={{md:12,xs:12}} container justifyContent="flex-end" alignItems="center" className="my-4">
                    <Grid size={{xs:12}} container className="mt-4 gap-md-4">
                        <Grid size={{md:3.8,xs:12}} onClick={()=>navigate("/catalogs/interviews-opportunity")} container flexDirection="column" justifyContent="space-between" className="grid_requestcatelog mt-3">
                            <img className='w-100' src={require('../../../assets/catalog/interviewcard.png')} alt='interview'/>
                            <h6>Interviews</h6>
                            <span>Use this to create a general case for support, questions, issue reporting, and daily work requests that require tracking and follow-up.</span>
                        </Grid>
                        {/* : <p className='w-100 text-center'>No Services</p>} */}

                        

                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default ConsultingServices
